import { createSlice } from "@reduxjs/toolkit";

const messagesSlice = createSlice({
    name: 'messages',
    initialState: {
        messagesCount: 0,
    },
    reducers: {
        setMessagesCount: (state, action) => {
            state.messagesCount = action.payload;
    
        },
    }
});

export const { setMessagesCount} = messagesSlice.actions;
export default messagesSlice.reducer;